<template>
    <div class="modal-content a-acceptanceAllGroupModal">
        <div class="modal-contentWrap">
            <div class="modal-header bg-1">
                <modal-close />
                <div class="modal-title mb-0 mb-md-2">
                    <h2 class="h3 mb-0">
                        {{ select ? 'Dodaj' : 'Odznacz' }} grupę promocji
                    </h2>
                </div>
            </div>
            <div class="modal-body ">
                <p class="text-primary text-center font-weight-bold pt-2">
                    <span v-if="select">
                        Aby dodać tę promocję do aktywacji należy dodać do
                        aktywacji całą grupę.
                    </span>
                    <span v-else>
                        Aby odznaczyć tę promocję należy odznaczyć całą grupę.
                    </span>
                </p>
            </div>

            <div
                class="modal-footer bg-1 border-0 pt-0 d-flex justify-content-between a-acceptanceAllGroupModal__footer"
            >
                <button
                    @click="onModalClose"
                    class="a-acceptanceAllGroupModal__footerBtn btn btn-outline-custom pl-5 pr-5"
                >
                    <a-icon icon="ArrowLeft" />Anuluj
                </button>
                <button
                    @click="onGroupAddDeleteClick"
                    type="button"
                    class="a-acceptanceAllGroupModal__footerBtn btn btn-secondary pl-5 pr-5"
                    :id="
                        `${select ? 'add-to' : 'remove-from'}-card-promo-group`
                    "
                    :disabled="isLoadingGroupStatus"
                >
                    <span> {{ select ? 'Dodaj' : 'Odznacz' }} grupę</span>
                    <a-icon
                        :icon="isLoadingGroupStatus ? 'Spinner' : 'ArrowRight'"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        acceptance: { type: String, default: '' },
        groupId: { type: Number, default: 0 },
        promoId: { type: Number, default: 0 },
        select: { type: Boolean, default: false }
    },
    data() {
        return {}
    },
    methods: {
        onModalClose() {
            this.$store.dispatch('toggleModal', false)
        },
        onGroupAddDeleteClick() {
            this.$store.dispatch('selectPromoGroupPromo', {
                promoId: this.id,
                groupId: this.groupId,
                select: this.select,
                acceptance: this.acceptance,
                addPromoWholeGroup: true
            })
        }
    },
    computed: {
        isLoadingGroupStatus() {
            return (
                this.$store.getters.getPromoGroup(this.groupId)?.status ===
                'loading'
            )
        }
    }
}
</script>
